import { theme } from "@tm/utility/global";
import styled from "styled-components";
import { deviceType } from "../../../../utils";

// ── Modal-level layout ──────────────────────────────────────────────────

export const TravellerFormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 24px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  overflow-x: hidden;

  @media ${deviceType.mobile} {
    padding: 0;
    max-height: 100%;
  }
`;

export const ModalFooter = styled.div`
  position: sticky;
  bottom: 0;
  background: ${theme.whiteText};
  padding: 8px 30px 0;
  margin: auto -30px 0 -30px;
  border-top: 1px solid ${theme.lightSilver};
  display: flex;
  flex-direction: column;
  z-index: 10;

  @media ${deviceType.mobile} {
    position: fixed;
    left: 0;
    right: 0;
    padding: 0;
    margin: 0;
    border-top: none;
  }
`;

export const ModalFooterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media ${deviceType.mobile} {
    padding: 16px;
  }
`;

interface SaveButtonProps {
  hasChanges?: boolean;
  isLoading?: boolean;
}

export const SaveButton = styled.button<SaveButtonProps>`
  padding: 12px 32px;
  background: ${(props) => {
    if (props.isLoading) return theme.blueText;
    if (props.hasChanges) return theme.blueText;
    return theme.greyText2;
  }};
  color: ${theme.whiteText};
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  cursor: ${(props) =>
    props.hasChanges && !props.isLoading ? "pointer" : "not-allowed"};
  transition: all 0.2s;
  min-width: 140px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    background: ${(props) => {
      if (props.isLoading || !props.hasChanges)
        return props.hasChanges ? theme.blueText : theme.greyText2;
      return theme.prussianBlue;
    }};
  }

  &:active {
    transform: ${(props) =>
      props.hasChanges && !props.isLoading ? "scale(0.98)" : "none"};
  }

  &:disabled {
    background: ${theme.greyText2};
    cursor: not-allowed;
    transform: none;
  }

  @media ${deviceType.mobile} {
    width: 100%;
    padding: 14px 32px;
  }
`;

export const AddButton = styled.button`
  padding: 8px 20px;
  background: transparent;
  border: 2px solid ${theme.blueText};
  border-radius: 8px;
  color: ${theme.blueText};
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  white-space: nowrap;
  text-transform: uppercase;
  min-width: fit-content;

  &:hover {
    background-color: ${theme.blueText};
    color: ${theme.whiteText};
  }

  &:active {
    transform: scale(0.98);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 140, 255, 0.3);
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const EditTravellersSheetStyle = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0px;
  z-index: 10;
  background-color: ${theme.disabledGrey2};
  overflow-y: scroll;
`;

export const SheetContent = styled.div`
  padding: 16px;
  padding-bottom: 100px;
`;

export const SheetFooter = styled.div`
  background: ${theme.whiteText};
  padding: 16px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
`;

export const SubmitModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  min-height: 200px;
`;

export const StickyErrorBanner = styled.div`
  background: #fcdadb;
  border: 1px solid #fcdadb;
  border-radius: 0;
  padding: 8px 32px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 -30px;
  box-sizing: border-box;

  @media ${deviceType.mobile} {
    padding: 8px 16px;
    margin: 0 -16px;
    position: fixed;
    bottom: 80px;
    left: 0;
    right: 0;
    z-index: 15;
  }
`;

export const StickyErrorIcon = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`;

export const StickyErrorText = styled.p`
  flex: 1;
  font-family: "Lato", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
  color: #4a4a4a;
  margin: 0;
  white-space: pre-wrap;
`;
